import { IconChevronDown } from '@koleso-icons';
import classNames from 'classnames';
import { TypePropsSelect } from './types';

import styles from './Select.module.scss';

export function MySelect({ children, className, classNameSelect, label, ...props }: TypePropsSelect) {
  return (
    <div className={classNames(styles.WrapperSelect, className)}>
      {label && <label>{label}</label>}
      <div className={classNames(styles.ContainerSelect, classNameSelect)}>
        <select {...props}>{children}</select>
        <IconChevronDown className={styles.iconArrow} />
      </div>
    </div>
  );
}
